import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Pages/home/";
import ProblemsList from "./Pages/problemsList/";
import Problems from "./Pages/problem/";
import SystemDesign from "./Pages/systemDesign";
import NotFoundPage from "./Pages/404/";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <Router>
      <div>
        <Header />
      </div>
      <Switch>
        <Route path="/problems/:problemUrl" component={Problems} />
        <Route path="/problems" component={ProblemsList} />
        <Route path="/404" component={NotFoundPage} />
        <Route path="/system-design" component={SystemDesign} />
        <Route path="/" exact={true} component={Home} />
        {/* <Route component={NotFoundPage} /> */}
      </Switch>
    </Router>
  );
}

export default App;
